export default function PreOrder() {
	return (
		<div id="sitePreorder">
			<a
				href="https://metaphor.atlus.com/index.html?lang=en"
				target="_blank"
			>
				<img
					src="https://s3.kftus.com/kft-cms/Pre_order_358841adf8.webp"
					style={{
						width: "100%"
					}}
				></img>
			</a>
		</div>
	);
}
